// extracted by mini-css-extract-plugin
export default {"loadmore":"OrderFiles_loadmore__v5m6r"};